import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/sites-builder/services/utils.service';
import { Breadcrumbs } from './models/breadcrumbs.model';
import { BreadcrumbsService } from './service/breadcrumbs.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  @Input() breadcrumbs: Array<Breadcrumbs> = [];
  private subscriptions: Array<Subscription> = [];

  constructor(
    private utilsService: UtilsService,
    private changeDetector: ChangeDetectorRef,
    private breadcrumbsService: BreadcrumbsService
  ) {}

  ngOnInit(): void {
    // console.log("init");
    const sync$ = this.breadcrumbsService.get$().subscribe(res => {
      this.breadcrumbs = res;
      // console.log('Breadcrumps: ', this.breadcrumbs);
      this.changeDetector.detectChanges();
    });
    this.subscriptions.push(sync$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public redirectRefreshed(url: string) {
    this.utilsService.redirectRefreshed((window.location.href = url));
  }
}
